<template>
    <div class="home">
        <layout>
            <template slot="content">
                <a>
                    <img src="@/assets/images/home/banner.jpg" class="contentImg"/>
                </a>
                <img src="@/assets/images/home/content1.jpg" class="contentImg"/>
                <img src="@/assets/images/home/content2.jpg" class="contentImg"/>
                <img src="@/assets/images/home/content3.jpg" class="contentImg"/>
                <img src="@/assets/images/home/content4.jpg" class="contentImg"/>
                <img src="@/assets/images/home/content5.jpg" class="contentImg"/>
                <img src="@/assets/images/home/content6.jpg" class="contentImg"/>
                <img src="@/assets/images/home/content7.jpg" class="contentImg"/>
            </template>
        </layout>
    </div>
</template>

<script>
import Layout from '@/components/Layout/index.vue'
export default {
    name:'',
    components: {
        Layout
    },
    props:{},
    data() {
        return {

        };
    },
    computed: {},
    watch: {},
    created() {},
    mounted() {},
    methods: {},
}
</script>
<style scoped>
.contentImg{
    width: 100%;
    float: left;
}
</style>